// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"XX-z","sponsoredTooltipWrapper":"YX-z","sponsoredTooltip":"ZX-z","newCard":"_X-z"};